import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ContentTooltip' })
export class ContentTooltipPipe implements PipeTransform {
    transform(input: any[], key: string): any {
        const item = input?.find(x => x.contentTooltipKey.toLowerCase() == key.toLowerCase());
        if (item) {
            return item.contentTooltipValue ?? key;
        }
        else {
            //console.log('ContentTooltip not found', key);
            return key;
        }
    }
}
